import React from 'react';
import { Modal } from 'antd';
import EligibilityChecklist from '../../../../components/eligibility/eligibility-checklist';
import type { EligibilityKind } from '../../../../api/user/eligibility.api';
import { getAdminEligibility } from '../../../../api/admin/user.api';

interface Props {
  userId: string | null;
  kind: EligibilityKind;
  /** Tên tài khoản để admin biết đang xem ai. */
  name?: string;
  onClose: () => void;
}

/** Admin xem danh sách điều kiện của một tài khoản, chỉ đọc. */
const EligibilityDialog = ({ userId, kind, name, onClose }: Props) => (
  <Modal
    open={!!userId}
    title={
      kind === 'donate'
        ? `Điều kiện mở nhận donate${name ? ` của ${name}` : ''}`
        : `Điều kiện tích xanh creator${name ? ` của ${name}` : ''}`
    }
    onCancel={onClose}
    footer={null}
    width={640}
    destroyOnClose
  >
    {userId && (
      <EligibilityChecklist
        kind={kind}
        readOnly
        loaderKey={`${kind}:${userId}`}
        loader={() => getAdminEligibility(userId, kind)}
      />
    )}
  </Modal>
);

export default EligibilityDialog;
